export enum UserGroups {
  PPM = 'FN_PRODUCEIT_PRODUCTION_MANAGER',
  FA = 'FN_PRODUCEIT_FINANCE_APPROVER',
  Designer = 'FN_PRODUCEIT_DESIGNER',
  CREATIVE_DIRECTOR = 'FN_PRODUCEIT_CREATIVE_DIRECTOR',
  TM = 'FN_PRODUCEIT_TRAFFIC_MANAGER',
  CD = 'FN_PRODUCEIT_CREATIVE_DIRECTOR',
  POP_PPM = 'FN_PRODUCEIT_POP_PRODUCTION_MANAGER',
  FSR_PPM = 'FN_PRODUCEIT_FSR_PRODUCTION_MANAGER',
  BIF_PPM = 'FN_PRODUCEIT_BIF_PRODUCTION_MANAGER',
  IH_PPM = 'FN_PRODUCEIT_IHA_PRODUCTION_MANAGER',
  THIRD_PARTY_PPM = 'FN_PRODUCEIT_3RD_PARTY_CARD_PRODUCTION_MANAGER',
  IM_TM = 'FN_PRODUCEIT_IMAGE_TRAFFIC_MANAGER',
}
